import React from "react";
const ApiDefinitions: React.FC = () => {
  return (<>
    <h1>API Definitions</h1>
  </>)
}
export default ApiDefinitions;